module.exports = __webpack_public_path__ + "static/media/step4.c13a266f.svg";